import React from "react"
import StatusType from "@irati/wallet/types/enums/Status"
import FormattedMessage, {InjectIntl} from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"
import Button from "@irati/ui/src/Button"
import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {ListScheduledRewards} from "@irati/types"
import withBranding from "@irati/brand/withBranding"
import {useDeleteBulkReward} from "@irati/wallet/hooks/rewards"
import Loading from "@irati/ui/src/Loading"
import ExpanderItem from "../../ExpanderItem"
import PrimaryDetails from "../../PrimaryDetails"
import {Details, DetailsContainer} from "./Details"
import {useDownloadReport} from "./downloadReport"

interface Props {
  formatMessage: InjectIntl["formatMessage"]
  reward: ListScheduledRewards
  onEdit(): void
  onDelete(): void
}

export const ScheduledReward = withBranding<Props>(function ScheduledRewardComp({reward, branding, formatMessage, onEdit, onDelete}) {
  const [downloadReport, reportStatus] = useDownloadReport(reward)
  const [deleteReward, deleteStatus] = useDeleteBulkReward({variables: {id: reward.uuid}})
  const msg = formatMessage({id: "wallet.statementItem.adminReward.scheduledReward.title"}, {count: reward.recipientCount})

  return (
    <Spacing marginBottom={4}>
      <ExpanderItem
        PrimaryElement={() => (
          <PrimaryDetails
            imgHeightAuto
            data={{
              title: msg,
              subTitle: formatMessage({id: "wallet.statementItem.adminReward.transfer.subTitle"}),
              image: branding.businessLogoUrl,
              amount: reward.amount * reward.recipientCount,
              currency: reward.currency,
              status: StatusType.SCHEDULED_SPEND
            }}
          />
        )}
        SecondaryElement={
          <Details>
            <DetailsContainer>
              <Body small>{msg}</Body>
              <Body small>
                <FormattedMessage id="wallet.secondaryDetails.viewMessage.message" values={{message: reward.message}} />
              </Body>

              <Loading load={reportStatus.load} useLoader={false} />
              <Loading load={deleteStatus.load} useLoader={false} />

              <Flex gap={2} wrap="wrap">
                <Button small onClick={onEdit}>
                  <FormattedMessage id="wallet.statementItem.adminReward.scheduledReward.ctaEdit" />
                </Button>
                <Button small apolloState={reportStatus} onClick={() => downloadReport()}>
                  <FormattedMessage id="wallet.statementItem.adminReward.scheduledReward.ctaDownload" />
                </Button>
                <Button
                  small
                  apolloState={deleteStatus}
                  onClick={() => {
                    deleteReward()
                      .then(onDelete)
                      .catch(() => {})
                  }}>
                  <FormattedMessage id="platform.button.delete" />
                </Button>
              </Flex>
            </DetailsContainer>
          </Details>
        }
      />
    </Spacing>
  )
})
